module.exports = __webpack_public_path__ + "static/media/bike.6c232f02.svg";